import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setAddContactPerson, setStates } from "./formSlice";
import { setShowServerErrorMessage } from "./errorManagementSlice";
import errorStatusProvider from "../utils/errorStatusProvider";

const initialState = {
  page_content: null,
  loading: true,
  error: null,
};

const baseUrl = process.env.REACT_APP_API;

export const fetchAddContactPerson = createAsyncThunk(
  "addContactPersonScreen/fetchAddContactPerson",
  async (country) => {
    const apiUrl = country?.companyType
      ? `${baseUrl}/api/add-contact-person/${country.countryCode}/?company_type=${country.companyType}`
      : `${baseUrl}/api/add-contact-person/${country.countryCode}/`;
    return fetch(apiUrl, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Accept-Language":
          country.language === "en" ? "en-UK" : country.language,
      },
    }).then((res) => errorStatusProvider(res));
  }
);

export const getAddContactPerson =
  (countryCode, language, companyType) => async (dispatch) => {
    const result = await dispatch(
      fetchAddContactPerson({ countryCode, language, companyType })
    );

    const { data, responseStatus } = result.payload;
    dispatch(setShowServerErrorMessage(responseStatus));
    dispatch(setAddContactPerson(data?.page_content));
    if (data?.page_content?.states)
      dispatch(setStates(data?.page_content?.states?.value[0]));

    return data;
  };

export const addContactPersonSlice = createSlice({
  name: "addContactPersonScreen",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAddContactPerson.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAddContactPerson.fulfilled, (state, action) => {
        state.loading = false;
        state.page_content = action.payload.data.page_content;
      })
      .addCase(fetchAddContactPerson.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export default addContactPersonSlice.reducer;
